"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var combineLearningPanelUrl_1 = __importDefault(require("./combineLearningPanelUrl"));
var rest_1 = __importDefault(require("../../../rest"));
var certificateApi_1 = __importDefault(require("../../mock/learningPanel/certificateApi"));
var CourseCertificateAPI = {
    getCourseCertificate: function (courseUuid) {
        return rest_1.default.get({
            mockFunc: function () { return certificateApi_1.default; },
            url: (0, combineLearningPanelUrl_1.default)("/users/course-certificate-preview-data/".concat(courseUuid)),
        });
    },
};
exports.default = CourseCertificateAPI;
